import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { periodColumnDefinition } from '../../shared/columnDefinitions';
import columnDefinitions from '../../shared/columnDefinitions/adminTaxEntrySettings';

const columnDefinitionsToExport = [
  periodColumnDefinition,
  ...columnDefinitions,
];

export default ({
  periodName,
  entities,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}) => xlsxExport({
  sheetData: [{
    name: 'Tax Entry',
    type: SheetExportTypes.GRID,
    columnDefinitions: columnDefinitionsToExport,
    data: entities,
    options: {
      shouldDisplayZero, hideDecimals, negativeMinus,
    },
  }],
  metadata: {
    fileName: `TLS_Balance_Sheet_Management_Tax_Entry_${periodName}${environmentSuffix}`,
  },
});
